export * from './charts';
export * from './series';
export * from './components';
export * from './VChart';
export * from './VChartSimple';

// export the version, since @1.8.3
export const version = "2.0.3";

export type {
  IAreaChartSpec,
  IBarChartSpec,
  IBar3dChartSpec,
  IBoxPlotChartSpec,
  ICirclePackingChartSpec,
  ICommonChartSpec,
  IFunnelChartSpec,
  IFunnel3dChartSpec,
  IGaugeChartSpec,
  IHeatmapChartSpec,
  IHistogramChartSpec,
  IHistogram3dChartSpec,
  ILineChartSpec,
  IMapChartSpec,
  IPieChartSpec,
  IPie3dChartSpec,
  ICircularProgressChartSpec,
  ILinearProgressChartSpec,
  IRadarChartSpec,
  IRangeColumnChartSpec,
  IRangeColumn3dChartSpec,
  IRangeAreaChartSpec,
  IRoseChartSpec,
  IScatterChartSpec,
  ISankeyChartSpec,
  ISequenceChartSpec,
  ISunburstChartSpec,
  ITreemapChartSpec,
  IWaterfallChartSpec,
  ICorrelationChartSpec,
  ILiquidChartSpec,
  IWordCloud3dChartSpec,
  IWordCloudChartSpec,
  IPolarChartSpec,
  ICartesianChartSpec,
  ITheme,
  IInitOption,
  ISpec,
  IVChart
} from '@visactor/vchart';
